export const safeJsonParse = (stringJson, defaultBack = '') => {
  try {
    return JSON.parse(stringJson)
  } catch (err) {
    return defaultBack
  }
}
